import global from "@/locales/lv-LV/global";
import error403 from "@/locales/lv-LV/errors/403";
import error404 from "@/locales/lv-LV/errors/404";
import error500 from "@/locales/lv-LV/errors/500";
import error503 from "@/locales/lv-LV/errors/503";
import error504 from "@/locales/lv-LV/errors/504";
import maintenance from "@/locales/lv-LV/auth/maintenance";
import toast from "@/locales/lv-LV/toast/toast";
import login from "@/locales/lv-LV/auth/login";
import onboarding from "@/locales/lv-LV/auth/onboarding";
import loginPageSteps from "@/locales/lv-LV/loginPageSteps";
import dashboard from "@/locales/lv-LV/dashboard/dashboard";
import account from "@/locales/lv-LV/account/account";
import mailbox from "@/locales/lv-LV/account/mailbox";
import bankstatement from "@/locales/lv-LV/account/bankstatement";
import myApps from "@/locales/lv-LV/my-apps/myApps";
import about from "@/locales/lv-LV/about/about";
import contactService from "@/locales/lv-LV/about/contactService";
import salesPromotions from "@/locales/lv-LV/sales/promotions";
import brochures from "@/locales/lv-LV/sales/brochures";
import shop from "@/locales/lv-LV/shop/data";
import priceList from "@/locales/lv-LV/shop/priceList";
import staff from "@/locales/lv-LV/dashboard/staff";
import promotions from "@/locales/lv-LV/promotions";
import points from "@/locales/lv-LV/points";
import trainings from "@/locales/lv-LV/trainings/trainings";
import vouchers from "@/locales/lv-LV/vouchers/vouchers";
import media from "@/locales/lv-LV/media/index";
import product from "@/locales/lv-LV/product/index";
import message from "@/locales/lv-LV/message/index";
import commitmentLetter from "@/locales/lv-LV/account/commitmentLetter";
import multiplicator from "@/locales/lv-LV/multiplicator";
import widgets from "@/locales/lv-LV/widgets/widgets";
import consents from "@/locales/lv-LV/consents/consents";
import investment from "@/locales/lv-LV/investment/data";
import kickback from "@/locales/lv-LV/kickback";
//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Produktu attēli",
    BDriveLinkText: "Saite uz PRODUKTU ATTĒLU portālu",
  },
}

export default {
  locale: "lv-LV",
  messages,
};
